export default {
  methods: {
    targetToUrl (target) {
      switch (target) {
        case 'TargetedVehicleRange':
          return '/products/engine-management/targeted-range/vehicle'
        case 'TargetedBikeRange':
          return '/products/engine-management/targeted-range/bike'
        case 'TargetedMarineRange':
          return '/products/engine-management/targeted-range/marine'
        case 'TargetedSnowmobileRange':
          return '/products/engine-management/targeted-range/snowmobile'
        case 'TargetedATVRange':
          return '/products/engine-management/targeted-range/atv'
        case 'TargetedCategoryRange':
          return '/products/engine-management/targeted-range/category'
        case 'TargetedOtherRange':
          return '/products/engine-management/targeted-range/other'
        default:
          return null
      }
    }
  }
}
